import './HeroSection.scss';

export { default } from './HeroSection';
